import Box from '@mui/material/Box';
import { InfiniteListBase, WithListContext } from 'react-admin';
import { get, map, nth } from 'lodash';
import useGetAvatar from '@/hooks/useGetAvatar';
import { composeUri } from '@/utils/compose';
import {
    AUDIT_METADATA_AVATAR_TYPE_NAME,
    AVATARS,
    DISORDER_METADATA_AVATAR_TYPE_NAME,
    TREATMENT_METADATA_AVATAR_TYPE_NAME,
} from '@/utils/CONST';
import DisordersTreatmentExportItem from '@/components/interventions/export-intervention/disorders-treatment-export-item';

interface ExportInterventionDisordersTreatmentSectionProps {
    interventionId: string;
}

const ExportInterventionDisordersTreatmentSection = ({ interventionId }: ExportInterventionDisordersTreatmentSectionProps) => {
    const { avatar: intervention, isLoading: isLoadingInt } = useGetAvatar({ avatarUriId: composeUri(AVATARS, interventionId) });

    const interventionGroupAvatar: any = nth(get(intervention, 'groupAvatars'), 0);

    if (isLoadingInt || !interventionGroupAvatar) {
        return null;
    }

    return (
        <Box>
            <InfiniteListBase
                resource={AVATARS}
                filter={{
                    metadataAvatarTypeEName: [
                        TREATMENT_METADATA_AVATAR_TYPE_NAME,
                        DISORDER_METADATA_AVATAR_TYPE_NAME,
                        AUDIT_METADATA_AVATAR_TYPE_NAME,
                    ],
                    enabled: true,
                    'groupAvatars.id': interventionGroupAvatar,
                }}
                storeKey='DisordersTreatmentExportList'
                sort={{
                    field: 'creationDate',
                    order: 'DESC',
                }}
                perPage={100}
                disableSyncWithLocation
                queryOptions={{
                    enabled: !!interventionGroupAvatar,
                }}
            >
                <WithListContext
                    render={({ data }) => (
                        <Box
                            sx={{
                                display: 'grid',
                                gap: 2,
                            }}
                        >
                            {map(data, (item, index) => (
                                <Box
                                    key={item.id}
                                    sx={{
                                        pageBreakBefore: 'always',
                                    }}
                                >
                                    <DisordersTreatmentExportItem item={item} index={index} />
                                </Box>
                            ))}
                        </Box>
                    )}
                />
            </InfiniteListBase>
        </Box>
    );
};

export default ExportInterventionDisordersTreatmentSection;

